<template>
    <div class="space-y-6">
        <UiTextarea
            id="points_balances"
            name="points_balances"
            label="Please share your current points and mileage balances"
            placeholder="e.g. Chase UR: 250k, Amex MR: 120k, United: 80k"
            v-model:inputValue="form.points_balances"
            :errors="errors"
            :options="{ required: true }"
        >
            <!-- Bookers plan the whole search around these numbers, so the
                 reminder to check them is deliberately loud. -->
            <template #hint>
                <p class="py-1.5 text-sm font-bold text-orange-700 dark:text-orange-400">
                    {{ balancesReminder }}
                </p>
            </template>
        </UiTextarea>

        <FormYesNo
            label="Are you willing to purchase miles to top off an account (if needed)?"
            name="willing_to_purchase_miles"
            v-model="form.willing_to_purchase_miles"
            :errors="errors"
            required
        />

        <UiTextarea
            id="additional_notes"
            name="additional_notes"
            label="Anything else you'd like us to know?"
            v-model:inputValue="form.additional_notes"
            :errors="errors"
            :options="{ optional: true }"
        />

        <UiInput
            id="promo_code"
            name="promo_code"
            label="Promo code"
            v-model:inputValue="form.promo_code"
            :errors="errors"
            hint="Applied to your final invoice."
            :options="{ optional: true }"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import UiTextarea from '@/components/ui/inputs/ui-textarea.vue';
import FormYesNo from '@/components/award-bookings/request-form/form-yes-no.vue';

const props = defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: null },
    balancesPrefilled: { type: Boolean, default: false },
});

const balancesReminder = computed(() =>
    props.balancesPrefilled
        ? 'We\'ve filled these in from the balances you track on My Points — review and adjust anything that\'s changed before submitting.'
        : 'Take a moment to make sure your balances are up to date — our bookers plan around them.'
);
</script>
